import { ZfBox, ZfDrawerSidePanelItem, ZfDrawerSidePanelList, ZfInput, ZfStack, ZfTextButton } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { ITranslation } from '../../interfaces/generic';
import { isTranslation } from '../../interfaces/generic';

interface IAdminItem {
    id: number;
    name: ITranslation | string;
}

interface IProps {
    items: IAdminItem[];
    highlightItemId?: number;
    onItemClick: (itemId: number) => void;
    onCreateClick: () => void;
}

export const AdminItemSearchList: FunctionComponent<IProps> = ({ items, highlightItemId, onItemClick, onCreateClick }) => {
    const { i18n, t } = useTranslation();

    const [searchValue, setSearchValue] = useState('');

    if (!items) {
        return null;
    }

    const visibleItems = searchValue.length > 2 ? items.filter((p) => JSON.stringify(p.name).toLowerCase().includes(searchValue.toLowerCase())) : items;

    return (
        <ZfStack
            direction="column"
            spacing="large"
            style={{ flex: 1, padding: 'var(--padding-vertical-xxl) var(--padding-horizontal-lg)', maxHeight: '100%', minWidth: '25vw' }}
        >
            <ZfTextButton hierarchy="secondary" onClick={onCreateClick}>
                {t('contentAdmin.createNewItem')}
            </ZfTextButton>
            {items.length > 1 && (
                <ZfInput
                    type="search"
                    value={searchValue}
                    placeholder={t('contentAdmin.searchPlaceholder')}
                    showSubmit={true}
                    clearable={false}
                    onInputChange={(e) => setSearchValue(e.detail)}
                />
            )}
            <ZfBox style={{ overflow: 'auto', flex: 1 }}>
                <ZfDrawerSidePanelList expanded={true}>
                    {visibleItems.map((item) => (
                        <ZfDrawerSidePanelItem
                            key={item.id}
                            expanded={true}
                            titleText={isTranslation(item.name) ? item.name[i18n.language] : item.name}
                            value={`${item.id}`}
                            selected={highlightItemId === item.id}
                            onSidePanelItemSelect={() => onItemClick(item.id)}
                        />
                    ))}
                </ZfDrawerSidePanelList>
            </ZfBox>
        </ZfStack>
    );
};
